import { render, staticRenderFns } from "./TickerSearchModal.vue?vue&type=template&id=284129a4"
import script from "./TickerSearchModal.vue?vue&type=script&lang=js"
export * from "./TickerSearchModal.vue?vue&type=script&lang=js"
import style0 from "./TickerSearchModal.vue?vue&type=style&index=0&id=284129a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Spinner: require('/skade-pwa/components/ui/atom/Spinner.vue').default,TickerSearchCardSkeleton: require('/skade-pwa/components/ui/atom/skeleton/TickerSearchCardSkeleton.vue').default,Modal: require('/skade-pwa/components/ui/atom/Modal.vue').default})
